import { dndDialogModifier } from "../utils/dnd-dialog-modifier";
import { findParentDialog } from "../utils/find-parent-dialog";
export var useDndDialogModifier = function (_a) {
  var ref = _a.ref;
  var modifiers;
  if (ref === null || ref === void 0 ? void 0 : ref.current) {
    var dragOverlayContainer = findParentDialog(ref === null || ref === void 0 ? void 0 : ref.current);
    var dialogRect = dragOverlayContainer === null || dragOverlayContainer === void 0 ? void 0 : dragOverlayContainer.getBoundingClientRect();
    if (dialogRect) {
      modifiers = [dndDialogModifier(dialogRect.x, dialogRect.y)];
    }
  }
  return modifiers;
};